import { Spinner } from "construct-ui"

export default function AdssoMobileLoginSuccessView() {
  return {
    view: function (vnode) {
      return m(Spinner, {
        active: true,
        background: true,
        fill: true,
        size: 'xl',
      })
    }
  }
}